import { KnockFeedProvider } from '@components/NotificationFeed/KnockFeedProvider';
import {
  NotificationIconButton,
  NotificationFeedPopover,
  NotificationCell
} from '@knocklabs/react';
import React, { useRef, useState } from 'react';
import '@knocklabs/react/dist/index.css';
import { useNavigate } from 'react-router-dom';
import UserAvatar from '@components/UserAvatar';
import './Notification.less';

export function NotificationFeed() {
  const [isVisible, setIsVisible] = useState(false);
  const buttonRef = useRef(null);
  const navigate = useNavigate();
  return (
    <KnockFeedProvider>
      <div className="notification-feed">
        <NotificationIconButton
          ref={buttonRef}
          onClick={() => setIsVisible(!isVisible)}
          badgeCountType="unseen"
        />
        <NotificationFeedPopover
          buttonRef={buttonRef}
          isVisible={isVisible}
          onClose={() => setIsVisible(false)}
          onNotificationClick={(item) => {
            const actionUrl = item.blocks
              .filter((x) => x.name === 'action_url')
              .filter((x) => x.type === 'text')
              .map((x) => new URL(x.rendered))
              .find(() => true);
            if (!actionUrl) return;
            if (actionUrl.host === window.location.host) {
              navigate(actionUrl.pathname + actionUrl.search);
            } else {
              window.open(actionUrl, '_blank')?.focus();
            }
          }}
          renderItem={({ item, ...props }) => {
            let avatar: React.ReactNode | undefined;
            if (item.actors.length) {
              const actor = item.actors[0];
              avatar = (
                <UserAvatar
                  size="large"
                  isActive
                  src={actor.avatar}
                  userName={actor.name}
                  userEmail={actor.email}
                  style={{ flexShrink: 0 }}
                />
              );
            }
            const images: Array<string> = Array.isArray(item.data?.top_assets)
              ? item.data.top_assets.map((x: any) => `${x.image}`)
              : typeof item.data?.asset_image === 'string'
              ? [item.data.asset_image]
              : [];
            const totalImages =
              typeof item.data?.assets_count === 'number'
                ? item.data.assets_count
                : images.length;
            return (
              <NotificationCell
                key={item.id}
                {...props}
                item={item}
                avatar={avatar}
              >
                {!!images.length && (
                  <div
                    style={{
                      display: 'grid',
                      width: 290,
                      gridTemplateColumns: `1fr 1fr`,
                      gap: 4
                    }}
                  >
                    {images.map((src, index) => {
                      const moreOverlay =
                        totalImages > images.length &&
                        index === images.length - 1;
                      return (
                        <div
                          key={index}
                          style={{
                            position: 'relative',
                            minWidth: 0,
                            width: '100%',
                            borderRadius: 6
                          }}
                        >
                          <img
                            alt="notification preview"
                            src={src}
                            style={{
                              width: '100%',
                              height: '100%',
                              aspectRatio: '16/9',
                              borderRadius: 6,
                              objectFit: 'cover'
                            }}
                          />
                          {moreOverlay && (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                background: 'rgba(22, 23, 24, 0.3)',
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontWeight: 'bold',
                                color: '#ffffff'
                              }}
                            >
                              +{totalImages - images.length}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </NotificationCell>
            );
          }}
        />
      </div>
    </KnockFeedProvider>
  );
}
